export function getMetricsQueryParams(search: string) {
	const queryString = new URLSearchParams(search);
	const startParam = queryString.get("start");
	const endParam = queryString.get("end");
	const audienceLists = queryString.getAll('audienceLists');

	return {
		start: startParam ? parseInt(startParam || '') : undefined,
		end: endParam ? parseInt(endParam || '') : undefined,
		audienceLists: audienceLists
	};
}

interface MetricParamsOptions {
	start?: Date | null;
	end?: Date | null;
	audienceList?: string[]
}

export function generateMetricsFilterParams(options: MetricParamsOptions) {
	const { start, end, audienceList } = options;

	const params = new URLSearchParams();
	if (start && end) {
		params.set('start', start.getTime().toString());
		params.set('end', end.getTime().toString());
	}

	if (audienceList?.length) {
		audienceList?.forEach(list => params.append('audienceLists', list));
	}

	const urlParams = params.toString();

	return urlParams ? `?${urlParams}` : '';
}
